import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Icon from "../common/Icon";
import { useState } from "react";
import { useEffect } from "react";
import { getPublicRows } from "../../services/contentService";

import Logo from "../common/Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/fleet", label: "Fleet" },
  { to: "/routes", label: "Routes" },
  { to: "/booking", label: "Booking" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [visibleLinks, setVisibleLinks] = useState(links);

  useEffect(() => {
    const fetchMenu = () => {
      getPublicRows("menu_items").then(({ data }) => {
        if (data?.length)
          setVisibleLinks(
            data
              .map((item) => ({ ...item, to: item.to || item.path }))
              .filter(
                (item) =>
                  item.to &&
                  !item.to.toLowerCase().includes("admin") &&
                  !item.label?.toLowerCase().includes("admin"),
              ),
          );
      });
    };
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      window.requestIdleCallback(fetchMenu, { timeout: 3500 });
    } else {
      setTimeout(fetchMenu, 2500);
    }
  }, []);

  function go(to) {
    setMobileOpen(false);
    navigate(to);
  }

  return (
    <div className="navwrap">
      <div className="nav">
        <Logo onClick={() => setMobileOpen(false)} />

        <div className="navlinks" id="navlinks">
          {visibleLinks.map((link) => (
            <NavLink key={link.id || link.to} to={link.to}>
              <button
                className={location.pathname === link.to ? "active" : ""}
                type="button"
              >
                {link.label}
              </button>
            </NavLink>
          ))}
        </div>

        <div className="nav-actions">
          <a
            className="btn btn-gold btn-call-now"
            href="tel:+918320342657"
            aria-label="Call Trishul Travels at +91 83203 42657"
          >
            <Icon name="ic-phone" size={15} />
            <span>Call Now</span>
          </a>
          <button
            className="hamb"
            type="button"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((open) => !open)}
          >
            <Icon name={mobileOpen ? "ic-close" : "ic-menu"} size={22} />
          </button>
        </div>
      </div>

      <div
        className={`mobile-panel ${mobileOpen ? "open" : ""}`}
        id="mobilePanel"
      >
        {visibleLinks.map((link) => (
          <button
            key={link.id || link.to}
            className={location.pathname === link.to ? "active" : ""}
            type="button"
            onClick={() => go(link.to)}
          >
            {link.label}
          </button>
        ))}
        <a
          href="tel:+918320342657"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: "var(--gold-300)",
            padding: "12px 4px",
            fontWeight: 700,
            fontSize: "0.95rem",
            borderBottom: "1px solid rgba(255,255,255,.06)",
          }}
          onClick={() => setMobileOpen(false)}
        >
          <Icon name="ic-phone" size={16} />
          Call Us (+91 83203 42657)
        </a>
      </div>
    </div>
  );
}
